import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { useFieldContext } from '@/domain/mitarbeiter/features/anlageassistent/components/form/hooks';
import { FieldProps } from '@/domain/mitarbeiter/features/anlageassistent/components/form/types';
import { InputDatePicker } from '@e2n/ui/v2';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export function DatePickerInput({
  label,
  isRequired,
  description,
  className,
  disabled,
  infoText,
  placeholder,
  ...props
}: FieldProps) {
  const field = useFieldContext<string | undefined>();
  const { t } = useTranslation();

  return (
    <FieldBase
      label={label}
      isRequired={isRequired}
      description={description}
      className={className}
      infoText={infoText}
      {...props}>
      <InputDatePicker
        id={field.name}
        name={field.name}
        value={
          field.state.value ? dayjs(field.state.value).toDate() : undefined
        }
        onChange={(d) => field.handleChange(dayjs(d).toISOString())}
        onBlur={field.handleBlur}
        disabled={disabled}
        placeholder={placeholder ?? t('general.date.dateInput.placeholder')}
      />
    </FieldBase>
  );
}
